// Turbolinks 5.2 keys every <head> element by its outerHTML. With a header-delivered
// CSP (report-only included) browsers blank the live `nonce` attribute, so the tracked
// pack tag never matched the one in the next response and every visit became a full
// reload. Compare without nonces, and stamp the scripts Turbolinks re-creates with the
// nonce of the document's own CSP (Hotwire Turbo does the same via its csp-nonce meta).
const NONCE_ATTRIBUTE = /\snonce="[^"]*"/g
const withoutNonce = (html) => html.replace(NONCE_ATTRIBUTE, "")

// Read while the pack itself runs: the meta tag is replaced on every render, and the
// pack tag's attribute may already be blanked, but its `nonce` property keeps the value.
function documentNonce() {
  const meta = document.querySelector('meta[name="csp-nonce"]')
  const pack = document.currentScript
  return (
    (meta && meta.content) ||
    (pack && (pack.nonce || pack.getAttribute("nonce"))) ||
    ""
  )
}
const nonce = documentNonce()

// Both URLs carry no fragment, so a match means no redirect and the visit keeps its anchor.
function redirectedLocation(request) {
  const responseURL = request && request.xhr && request.xhr.responseURL
  return responseURL && responseURL !== request.url ? responseURL : null
}

export default function patchTurbolinksForCsp(Turbolinks) {
  const head = Turbolinks.HeadDetails.prototype
  head.getTrackedElementSignature = function () {
    return Object.keys(this.elements)
      .filter((key) => this.elements[key].tracked)
      .map(withoutNonce)
      .join("")
  }
  const hasElementWithKey = head.hasElementWithKey
  head.hasElementWithKey = function (key) {
    if (hasElementWithKey.call(this, key)) return true
    const wanted = withoutNonce(key)
    return Object.keys(this.elements).some(
      (candidate) => withoutNonce(candidate) === wanted
    )
  }

  const renderer = Turbolinks.Renderer.prototype
  const createScriptElement = renderer.createScriptElement
  renderer.createScriptElement = function (element) {
    const created = createScriptElement.call(this, element)
    if (created !== element && nonce) created.setAttribute("nonce", nonce)
    return created
  }

  // Turbolinks learns a redirect's final URL only from a Turbolinks-Location header,
  // which the turbolinks-rails gem sends and this app never has; the XHR already
  // followed the redirect, so take the URL it ended on.
  const visit = Turbolinks.Visit.prototype
  const requestCompletedWithResponse = visit.requestCompletedWithResponse
  visit.requestCompletedWithResponse = function (
    response,
    redirectedToLocation
  ) {
    return requestCompletedWithResponse.call(
      this,
      response,
      redirectedToLocation || redirectedLocation(this.request)
    )
  }
}
